import { FlagStateType, SupervisorAction, SupervisorSubPhase, WorkerAccessLevel } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { YEventPayload } from '../../models/y-protocol.model';

type Event = Omit<YEventPayload<AppEventType>, 'triggered'>;

export const demoEvents: Array<Event | Event[]> = [
    {
        name: AppEventType.SupervisorStateChange,
        data: {
            subPhase: SupervisorSubPhase.WaitingForSupervisor
        }
    },
    [
        {
            name: AppEventType.LoginChange,
            data: {
                new: {
                    accessLevel: WorkerAccessLevel.Supervisor,
                    id: 'BBBBBBBB',
                    location: 'Ljubljana Office',
                    name: 'Tronius Supervisor'
                },
                old: {
                    accessLevel: WorkerAccessLevel.Croupier,
                    id: 'FFFF0000',
                    location: 'Ljubljana',
                    name: 'Tronius Croupier'
                }
            }
        },
        {
            name: AppEventType.SupervisorStateChange,
            data: {
                subPhase: SupervisorSubPhase.ActionSelection
            }
        }
    ],
    {
        name: AppEventType.SupervisorStateChange,
        data: {
            subPhase: SupervisorSubPhase.ActionSelection,
            selectedAction: SupervisorAction.ChangeResult
        }
    },
    {
        name: AppEventType.SupervisorStateChange,
        data: {
            subPhase: SupervisorSubPhase.GameSelection
        }
    },
    {
        name: AppEventType.SupervisorStateChange,
        data: {
            subPhase: SupervisorSubPhase.ConfirmAction,
            selectedAction: SupervisorAction.CloseTable
        }
    },
    [
        {
            name: AppEventType.FlagStateChange,
            data: {
                flag: FlagStateType.TableClosingRequested,
                state: true
            }
        },
        {
            name: AppEventType.LoginChange,
            data: {
                new: {
                    accessLevel: WorkerAccessLevel.None,
                    id: '',
                    location: '',
                    name: ''
                },
                old: {
                    accessLevel: WorkerAccessLevel.Supervisor,
                    id: 'BBBBBBBB',
                    location: 'Ljubljana Office',
                    name: 'Tronius Supervisor'
                }
            }
        },
        {
            name: AppEventType.SupervisorStateChange,
            data: {}
        },
        {
            name: AppEventType.LoginChange,
            data: {
                new: {
                    accessLevel: WorkerAccessLevel.Croupier,
                    id: 'FFFF0000',
                    location: 'Ljubljana',
                    name: 'Tronius Croupier'
                },
                old: {
                    accessLevel: WorkerAccessLevel.None,
                    id: '',
                    location: '',
                    name: ''
                }
            }
        }
    ]
];
